import dateTimeFormatted, {
  type DateFormat,
} from './dateFormatter/dateTimeFormatted';

export interface EventDateTimeParams {
  date?: string | null | undefined;
  endTime?: string | null | undefined;
  isWeddingDayEvent?: boolean;
  time?: string | null | undefined;
  weddingDateFormat?: string | null | undefined;
  isLiteSite?: boolean | undefined;
}

export function timeToLocaleString(
  time: string | null | undefined
): string | null {
  if (!time) return '';

  const timeDate = new Date(`2022/1/1 ${time} UTC`); // we only care about the time portion

  const formattedTime = dateTimeFormatted(timeDate, 'hoursMinutes');

  return formattedTime;
}

function getEventDateTime({
  date,
  endTime,
  isWeddingDayEvent,
  time,
  isLiteSite,
  weddingDateFormat = 'weekday',
}: EventDateTimeParams): EventDateTimeParams {
  let format = weddingDateFormat;

  if (format === 'range' || !isWeddingDayEvent) format = 'weekday';

  // keep Lite Site date format consistant
  if (isLiteSite) {
    format = 'weekday';
  }

  const dateWithTime = time && date ? `${date} ${time} UTC` : date;

  const formattedDate = dateTimeFormatted(dateWithTime, format as DateFormat);

  const formattedTime = timeToLocaleString(time);

  const formattedEndTime = timeToLocaleString(endTime);

  return {
    date: formattedDate,
    time: formattedTime,
    endTime: formattedEndTime,
  };
}

export default getEventDateTime;
